import { Wording } from '@/types';

export const PILATES_WORDING_HR: Wording = {
  components_header_media_content: 'Vježbe',
  components_header_media_1: '',
  components_header_text1: 'Recepti',
  components_header_text2: 'Blog',
  components_header_members: 'članovi',
  hero_text: 'Održavajte svoje tijelo fleksibilnim i jakim',
  hero_button_text: 'Započnite svoje pilates putovanje',
  components_ressources_section_title: 'RESURSI',
  components_ressources_subheader_text: 'Svi resursi koji su vam potrebni za skladan životni stil',
  components_ressources_span_text: 'Otključajte tajne dobrobiti: uronite u zbirku pilates vježbi i korisnih recepata za uspostavljanje ravnoteže u svakom aspektu vašeg života.',
  components_ressources_card_1_title: 'Savjeti za pilates',
  components_ressources_card_1_text: 'Praktični savjeti za produbljivanje prakse i usavršavanje rutine.',
  components_ressources_card_2_title: 'Dijeta',
  components_ressources_card_2_text: 'Pametni savjeti za ishranu za vas zdravije i jače.',
  components_ressources_link: 'Pogledajte videozapise',
  components_notes_and_google_title_1: 'pilates',
  components_notes_and_google_title_2: 'Redovita rutina',
  components_notes_and_google_title_3: 'Održavanje dijete',
  components_review_google_text: 'Recenzija na Googleu',
  media_content_section_title: 'VJEŽBANJA',
  media_content_section_subheader_text: 'Naši videi',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Više videa',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Članci i vijesti',
  text2_section_button_more: 'Više članaka',
  components_text1_section_title: 'RECEPTI',
  components_text1_subheader_text: 'Nahranite svoje tijelo i um',
  components_text1_span_text: 'Zdravi recepti koji će podržati vaše pilates rutine i poboljšati vaše blagostanje.',
  components_text1_card_1_title: 'Energizirajući doručak',
  components_text1_card_1_text: 'Probudite se uz živahne obroke koji daju energiju.',
  components_text1_card_3_title: 'Snažni ručkovi',
  components_text1_card_3_text: 'Otkrijte ukusne i praktične recepte za ručak namijenjene vašem aktivnom životnom stilu. Od šarenih salata do obloga prepunih bjelančevina, ovi vam recepti daju energiju i usredotočenost.',
  components_text1_card_2_title: 'Večere za oporavak',
  components_text1_card_2_text: 'Istražite razne nemasne proteine, cjelovite žitarice i živopisno povrće za zadovoljavajući kraj vašeg dana.',
  components_text1_link: 'Pogledajte sve recepte',
  components_footer_text: 'Pronađite ravnotežu, dišite duboko: Vaš pilates, Vaše putovanje.',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Matični broj',
  components_footer_legal: 'Pravno',
  components_footer_terms: 'Odredbe i uvjeti',
  components_footer_privacy: 'Politika privatnosti',
  button_load_more: 'Učitaj više',
  page_media_1_content_hero_text: 'Pilates vježbe',
  page_text1_hero_text: 'Recepti',
  page_text1_section_title: 'Prehrana',
  page_text1_subheader_text: 'Recepti',
  page_text2_hero_text: 'Naš blog',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Članci i vijesti',
  enter_email_title: 'Unesite svoju e-poštu za nastavak',
  enter_email_placeholder_email: 'E-mail',
  enter_email_button_enter: 'Uđi',
  components_login_success_text: 'Prijava uspješna!',
  components_card_link_media_content: 'Gledajte sada',
  components_card_link_text1_content: 'Pogledajte recept',
  components_card_link_text2_content: 'Pogledajte članak',
  france: 'Francuska',
  cyprus: 'Cipar',
};